import React from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from '@mui/material';
import {LoadingButton} from '@mui/lab';
import {formatBundleUpdateTags} from '../../../core/transfer/bundleUpdate';

export default function BundleUpdateConfirmDialog({
    open,
    source,
    target,
    items,
    bundleUpdateInfo,
    canConfirm,
    loading,
    onCancel,
    onConfirm
}) {
    return <Dialog
        open={open}
        onClose={onCancel}
        aria-labelledby="bundle-confirm-dialog-title"
        aria-describedby="bundle-confirm-dialog-description"
        maxWidth="xl"
        fullWidth
    >
        <DialogTitle id="bundle-confirm-dialog-title">
            Bundle version change on transfer from <b>{source}</b> to <b>{target}</b>
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="bundle-confirm-dialog-description" component="div">
                {!canConfirm ? <Alert severity="error">Недостаточно прав</Alert> : <>
                    <Alert severity="error" sx={{mb: 2}}>
                        Внимание! При трансфере у перечисленных элементов изменится версия бандла.
                        Проверьте список ниже и подтвердите, если уверены.
                    </Alert>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Bundle change</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.map(item => <TableRow selected key={item}>
                                <TableCell>{item}</TableCell>
                                <TableCell>
                                    bundle update to {formatBundleUpdateTags(bundleUpdateInfo[item]?.generations)}
                                    {bundleUpdateInfo[item]?.bundleId ? ` (${bundleUpdateInfo[item].bundleId})` : ''}
                                </TableCell>
                            </TableRow>)}
                        </TableBody>
                    </Table>
                </>}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" onClick={onCancel}>Cancel</Button>
            {canConfirm && <LoadingButton
                variant="contained"
                color="error"
                onClick={onConfirm}
                loading={loading}
                disabled={items.length === 0}
            >
                Yes, change the bundle
            </LoadingButton>}
        </DialogActions>
    </Dialog>;
}
